export default __webpack_public_path__ + "static/16-a59f9118b707723383d9b4209911e463.jpg";